import * as React from 'react';
import { IconProps } from '../types';

const IcMenuQuickView = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M10.36 6.9a6.391 6.391 0 0 1 3.802-1.358 6.412 6.412 0 0 1 3.587.975 6.515 6.515 0 0 1 2.618 3.193c.744 1.94.482 4.23-.701 5.94-.024.053-.1.101-.076.168.93.927 1.86 1.864 2.785 2.791.29.287.362.746.215 1.118a1.041 1.041 0 0 1-1.03.636.983.983 0 0 1-.65-.301c-.93-.937-1.869-1.869-2.799-2.806-1.145.823-2.556 1.272-3.963 1.215a6.43 6.43 0 0 1-4.708-2.242c-.992-1.147-1.573-2.657-1.56-4.182-.047-1.979.917-3.938 2.48-5.147Zm3.363.75c-.73.1-1.435.387-2.022.832a4.389 4.389 0 0 0-1.64 2.48 4.395 4.395 0 0 0 .214 2.753 4.47 4.47 0 0 0 2.165 2.275c.768.368 1.641.502 2.485.387.906-.12 1.77-.54 2.433-1.176a4.403 4.403 0 0 0-1.33-7.25 4.318 4.318 0 0 0-2.305-.301Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.936 1.064c.253-.052.535-.1.773.029.272.134.458.43.453.736-.002.619-.002 1.237-.002 1.856 0 .62 0 1.238-.003 1.857A6.402 6.402 0 0 0 10.356 6.9c-1.564 1.209-2.528 3.169-2.485 5.152-.01 1.52.568 3.035 1.56 4.182a6.447 6.447 0 0 0 4.707 2.241c.006.743.007 1.486.007 2.23 0 .496 0 .992.003 1.489.01.373-.282.717-.644.793-.207.034-.41-.006-.61-.046l-.163-.03-4.89-.89h-.002l-4.89-.888c-.286-.048-.524-.316-.52-.607V3.463c.01-.282.249-.525.52-.568 2.546-.475 5.09-.938 7.63-1.401l2.357-.43Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMenuQuickView;
